import { Router } from '@angular/router';
import { IconMenuButtonComponent } from 'src/app/shared/components/icon-menu-button/icon-menu-button.component';
import { DatePipe, NgStyle, NgClass, AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { lastValueFrom, Observable, of } from 'rxjs';
import { SupplierModel } from 'src/app/models/supplier.model';
import { PaidLaborUpdateModel } from 'src/app/models/paidLabor-update.model';
import { SupplierService } from 'src/app/services/supplier.services';
import { WorkloadsService } from 'src/app/services/workloads.service';
import { IndCalendarComponent } from 'src/app/shared/components/calendar/ind-calendar/ind-calendar.component';
import { UserService } from 'src/app/shared/services/user.service';
import Swal from 'sweetalert2';
import { ActivitiesLogsComponent } from '../../logs/activities-logs/activities-logs.component';
import { ToastService } from 'src/app/services/toast.service';
import { taskStatuses } from 'src/assets/data/task-statuses';
import { ContractorSearchModel } from 'src/app/models/contractor-search.model';
import { FormsService } from 'src/app/services/forms.service';
import { CompletedFormModel } from 'src/app/models/completedForm.model';
import { ProductQualityModel } from 'src/app/models/product-quality.model';
import { ProductService } from 'src/app/services/product.service';
import { ColorsModel } from 'src/app/models/colors.model';
import { ProductModel } from 'src/app/models/products';
import { thirdPartyApp } from 'src/assets/data/third-party-app';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Guid } from 'guid-typescript';
import { VisitModel } from 'src/app/models/visit.model';
import { WorkTaskService } from 'src/app/services/work-task.service';
import { AssemblyOrderService } from 'src/app/services/assembly-order.service';
import { FranchiseModel } from 'src/app/models/franchise.model';
import { CommonFunctionsConfiguratorService } from 'src/app/shared/services/swal-fire-configurator.service';
import { FileServerService } from 'src/app/services/file-server.service';
import { FileServerModel } from 'src/app/models/file-server.model';
import { TagService } from 'src/app/services/tag.service';
import { TagModel } from 'src/app/models/tag.model';
import { CompletedFieldModel } from 'src/app/models/completedField.model';
import { DistributionCenterModel } from 'src/app/models/distribution-center.model';
import { ClientInfoModalComponent } from './client-info-modal/client-info-modal.component';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem } from '@angular/material/menu';
import { HideIfNoPermissionDirective } from '../../../directives/HideIfNoPermissionDirective';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { MatFormField, MatLabel, MatInput, MatSuffix } from '@angular/material/input';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { ScheduleCompletionFormComponent } from '../schedule-completion-form/schedule-completion-form.component';
import { NgbCarousel, NgbSlide } from '@ng-bootstrap/ng-bootstrap';

/** Task detail dialog size, shared by every screen that opens it: half the screen on desktop, the full width
 * minus a gutter on phones. */
export const TASK_DETAIL_DIALOG_SIZE = {
  width: 'min(50vw, 960px)',
  minWidth: 'min(640px, calc(100vw - 32px))',
  maxWidth: 'calc(100vw - 32px)',
  maxHeight: '95vh',
};

@Component({
    selector: 'app-schedule-detail',
    templateUrl: './schedule-detail.component.html',
    styleUrls: ['./schedule-detail.component.scss'],
    imports: [IconMenuButtonComponent, MatIcon, MatMenu, MatMenuItem, HideIfNoPermissionDirective, MatTabGroup, MatTab, NgStyle, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatSelect, MatOption, NgClass, MatInput, MatCheckbox, MatAutocompleteTrigger, MatAutocomplete, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, NgxMaterialTimepickerModule, ActivitiesLogsComponent, ScheduleCompletionFormComponent, NgbCarousel, NgbSlide, AsyncPipe, DatePipe]
})
export class ScheduleDetailComponent implements OnInit {
  dialogRef = inject<MatDialogRef<ScheduleDetailComponent>>(MatDialogRef);
  private readonly router = inject(Router);
  eventData = inject(MAT_DIALOG_DATA, { optional: true });
  datepipe = inject(DatePipe);
  private readonly workLoadSvc = inject(WorkloadsService);
  private readonly assemblySvc = inject(AssemblyOrderService);
  private readonly supplierSvc = inject(SupplierService);
  usrSvc = inject(UserService);
  private readonly cdRef = inject(ChangeDetectorRef);
  toastr = inject(ToastService);
  private readonly productSvc = inject(ProductService);
  private readonly workTaskSvc = inject(WorkTaskService);
  private readonly formsSrv = inject(FormsService);
  private readonly swalFire = inject(CommonFunctionsConfiguratorService);
  private readonly fileServerSrv = inject(FileServerService);
  private readonly tagSrv = inject(TagService);
  private readonly dialog = inject(MatDialog);


  progressImages: FileServerModel[] = [];
  filteredOptions!: Observable<SupplierModel[]>;
  data: any = {};
  action: string = '';
  thirdPartyAppList = thirdPartyApp;
  taskCurrentStatus: any;

  TERRAIN_VISIT_ID: string = '1af64f64-5717-4562-b3fc-2c963f66cda1';

  indCalendarComponent!: IndCalendarComponent;

  minDate = new Date();
  minHour = '00:00';
  disabledSchedule = true;
  taskCanceled = false;
  taskPostponed = false;
  taskPresupuestada = false;
  taskClosed = false;
  waitingCustomers = false;

  supplierList: SupplierModel[] = [];
  selectedSupplier: SupplierModel | undefined;

  details: UntypedFormGroup = new UntypedFormGroup({
    details: new UntypedFormControl(),
  });
  durationForm: UntypedFormGroup = new UntypedFormGroup({});
  serialNumberForm: UntypedFormGroup = new UntypedFormGroup({});
  deliveryOrderForm: UntypedFormGroup = new UntypedFormGroup({});
  revetmentSurplusForm: UntypedFormGroup = new UntypedFormGroup({});
  promotionalTaskForm: UntypedFormGroup = new UntypedFormGroup({});
  paidLaberForm: UntypedFormGroup = new UntypedFormGroup({});
  pendingContactForm: UntypedFormGroup = new UntypedFormGroup({
    hasClientContact: new UntypedFormControl(false),
  });
  productForm: UntypedFormGroup = new UntypedFormGroup({});
  visitForm: UntypedFormGroup = new UntypedFormGroup({
    selectedVisitId: new UntypedFormControl(),
  });
  centroDistribucionForm: UntypedFormGroup = new UntypedFormGroup({});
  franchiseForm: UntypedFormGroup = new UntypedFormGroup({});
  warrantyForm: UntypedFormGroup = new UntypedFormGroup({
    poolWarrantyNumber: new UntypedFormControl('', Validators.maxLength(10)),
    externalIdentifier: new UntypedFormControl(),
  });
  schudeledDate: UntypedFormGroup = new UntypedFormGroup({});
  contractor: UntypedFormGroup = new UntypedFormGroup({
    contractorName: new UntypedFormControl(''),
  });
  currentContractorName = '';
  currentContractorDni = '';
  currentTaskId: Guid = Guid.createEmpty();
  cancel: UntypedFormGroup = new UntypedFormGroup({
    details: new UntypedFormControl('', [Validators.required]),
  });
  postponeOrToBudge: UntypedFormGroup = new UntypedFormGroup({
    details: new UntypedFormControl('', [Validators.required]),
  });
  taskStatuses: any[] = [];
  contractorError: string = '';
  canEditPaidLabor: boolean = false;
  canAsociateVisit: boolean = false;

  completionFroms: CompletedFormModel[] = [];
  startingForms: CompletedFormModel[] = [];
  siteVisitCompletionFrom: CompletedFormModel[] = [];
  transportationForms: CompletedFormModel[] = [];
  evaluationForm: CompletedFormModel[] = [];

  productsQualityList: ProductQualityModel[] = [];
  colorList: ColorsModel[] = [];
  visitsList: VisitModel[] = [];
  franchiseList: FranchiseModel[] = [];
  distributionsCenterList: DistributionCenterModel[] = [];

  @ViewChild('containerSummary') containerSummary!: ElementRef;
  @ViewChild(ActivitiesLogsComponent) logComponent!: ActivitiesLogsComponent;
  height: number = 0;
  private initialLoad = 0;
  private deleteContractorCounter = 0;
  public dataToUse: any; // variable para manejar datos en vista de historico de cliente

  availableTags: TagModel[] = [];

  selectedTags: TagModel[] = [];
  dropdownOpen = false;
  @ViewChild('dropdown') dropdownRef!: ElementRef;

  toggleDropdown(): void {
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectTag(item: TagModel, event: Event, taskId: string): void {
    event.stopPropagation();

    this.tagSrv.addTagToTask(item.id, taskId).subscribe({
      next: (data) => {
        this.toastr.success(
          'Etiquetas',
          'Se agregó exitosamente la etiqueta a la tarea.'
        );
      },
      error: (err) => {
        this.toastr.error(
          'Etiquetas',
          'No se pudo agregar la etiqueta a la tarea.'
        );
      },
    });

    this.selectedTags.push(item);

    this.availableTags = this.availableTags.filter((i) => i !== item);
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event): void {
    if (!this.dropdownRef?.nativeElement.contains(event.target)) {
      this.dropdownOpen = false;
    }
  }

  getTags() {
    this.tagSrv.getTags().subscribe({
      next: (data) => {
        this.availableTags = data;
      },
      error: (err) => {
        this.toastr.error(
          'Etiquetas',
          'No se pudo obtener la lista etiquetas.'
        );
      },
    });
  }

  get availableItems() {
    return this.availableTags.filter(
      (option) =>
        !this.selectedTags.some((selected) => selected.id === option.id)
    );
  }

  removeTag(tag: TagModel, taskId: string) {
    this.tagSrv.deleteTagToTask(tag.id, taskId).subscribe({
      next: (data) => {
        if (!this.availableTags.find((x) => x.id == tag.id)) {
          this.availableTags.push(tag);
        }
        this.selectedTags = this.selectedTags.filter((i) => i !== tag);
        this.toastr.success(
          'Etiquetas',
          'Se eliminó la etiqueta asignada a la tarea.'
        );
      },
      error: (err) => {
        this.toastr.error(
          'Etiquetas',
          'No se pudo eliminar la etiqueta asignada.'
        );
      },
    });
  }

  ngAfterViewInit() {
    this.height = this.containerSummary.nativeElement.offsetHeight;
    this.cdRef.detectChanges();
  }

  viewLog(event: any) {
    if (event.index == 1) {
      this.logComponent.getActivityLogs(this.currentTaskId);
    }
  }

  ngOnInit(): void {
    this.getStatusList();
    this.height = 0;

    if (this.eventData.event.data) {
      this.dataToUse = this.eventData.event.data;
    } else {
      this.dataToUse = this.eventData.event;
    }

    this.initializeData();
  }

  initializeData() {
    let taskId = this.dataToUse.id;
    this.workLoadSvc.getById(taskId).subscribe((val) => {
      this.data = val;
      this.selectedTags = this.data.tags;
      this.getTags();
      this.currentTaskId = this.data.id as Guid;
      this.getForms();

      this.initContractorList();

      this.getStatus(this.data.status);

      this.action = this.eventData.action;
      this.syncPaidLaborState();

      this.getProductQualityList();
      this.getProductColors(this.data.productId);
      this.getFranchises();
      this.getDistributionCenters();

      this.details = new UntypedFormGroup({
        details: new UntypedFormControl(this.data.details),
      });
      this.durationForm = new UntypedFormGroup({
        estimatedDuration: new UntypedFormControl(this.data.estimatedDuration),
      });
      this.serialNumberForm = new UntypedFormGroup({
        filterSerialNumber: new UntypedFormControl(
          this.data.filterSerialNumber
        ),
        valveSelectorSerialNumber: new UntypedFormControl(
          this.data.valveSelectorSerialNumber
        ),
      });
      this.revetmentSurplusForm = new UntypedFormGroup({
        revetmentSurplus: new UntypedFormControl(this.data.revetmentSurplus),
      });
      this.deliveryOrderForm = new UntypedFormGroup({
        deliveryOrder: new UntypedFormControl(this.data.deliveryOrder),
      });
      this.warrantyForm = new UntypedFormGroup({
        poolWarrantyNumber: new UntypedFormControl(
          this.data.poolWarrantyNumber,
          Validators.maxLength(10)
        ),
        externalIdentifier: new UntypedFormControl(
          this.data.externalIdentifier
        ),
      });
      this.promotionalTaskForm = new UntypedFormGroup({
        isPromotional: new UntypedFormControl(this.data.isPromotional),
        discountApplied: new UntypedFormControl(this.data.discountApplied),
      });
      this.paidLaberForm = new UntypedFormGroup({
        isPaidLabor: new UntypedFormControl(this.data.isPaidLabor),
      });
      this.pendingContactForm = new UntypedFormGroup({
        hasClientContact: new UntypedFormControl(this.data.hasClientContact),
      });

      this.canEditPaidLabor = this.data.canEditPaidLabor;

      this.checkDisabledWarrantiNumber();
      this.checkDisabledRevetmentSurplus();
      this.disableSerialNumberForm();
      this.disableDurationForm();
      this.disablePromotionalForm();
      this.disableDeliveryOrderForm();

      this.productForm = new UntypedFormGroup({
        productColorId: new UntypedFormControl(this.data.productColorId),
        productQualityId: new UntypedFormControl(this.data.productQualityId),
      });
      this.franchiseForm = new UntypedFormGroup({
        franchiseId: new UntypedFormControl(this.data.franchiseId),
      });
      this.schudeledDate = new UntypedFormGroup({
        date: new UntypedFormControl(this.data.schudeledDate, [
          Validators.required,
        ]),
        time: new UntypedFormControl(
          this.datepipe.transform(this.data.schudeledDate, 'HH:mm'),
          [Validators.required]
        ),
      });
      this.centroDistribucionForm = new UntypedFormGroup({
        centroDistribucionId: new UntypedFormControl(
          this.data.distributionCenterId
        ),
      });

      this.schudeledDate.valueChanges.subscribe(() => {
        if (this.initialLoad < 2) {
          this.initialLoad++;
          return;
        }
        if (
          (this.schudeledDate.controls.date.value &&
            this.datepipe.transform(
              this.schudeledDate.controls.date.value,
              'yyyy-MM-dd'
            ) !=
            this.datepipe.transform(this.data.schudeledDate, 'yyyy-MM-dd')) ||
          (this.schudeledDate.controls.time.value &&
            this.schudeledDate.controls.time.value !=
            this.datepipe.transform(this.data.schudeledDate, 'HH:mm'))
        ) {
          this.disabledSchedule = false;
        } else {
          this.disabledSchedule = true;
        }
        this.contractorError = '';
        this.initContractorList(true);
      });

      this.schudeledDate.controls['date'].valueChanges.subscribe(
        (val: Date) => {
          const selectedDate = new Date(val);
          const currentDate = new Date();

          if (
            selectedDate.getDate() === currentDate.getDate() &&
            selectedDate.getMonth() === currentDate.getMonth() &&
            selectedDate.getFullYear() === currentDate.getFullYear()
          ) {
            this.minHour = this.datepipe.transform(
              currentDate,
              'HH:mm'
            ) as string;
          } else {
            this.minHour = '00:00';
          }
        }
      );

      this.currentContractorName = this.data.contractorName;
      this.currentContractorDni = this.data.contractorDni;
      this.contractor.controls.contractorName.disable();
      this.details.disable();
      this.schudeledDate.controls.date.disable();
      // Not via [disabled] in the template: it warns when combined with formControlName. Silent, so it doesn't count as a user change.
      if (
        !(
          this.usrSvc.hasPermission('add:schedule') ||
          this.usrSvc.hasPermission('add:scheduleTerrain')
        )
      ) {
        this.schudeledDate.controls.time.disable({ emitEvent: false });
      }
    });
  }

  getVisits(clientId: string) {
    let taskType = this.data.taskType;

    this.workTaskSvc
      .getClientVisits(clientId)
      .subscribe((data: VisitModel[]) => {
        this.visitsList = data.filter((x) => x.consumed === false);
        this.canAsociateVisit =
          taskType == 'de Terreno' && this.visitsList.length > 0;
      });
  }

  initContractorList(refreshSchudeledDate: boolean = false) {
    if (!this.data) return;

    let filter: ContractorSearchModel = {
      categoryId: this.data.jobGroupId,
      subCategoryId: this.data.taskTypeId,
      latitude: this.data.address.coordinates.latitude,
      longitude: this.data.address.coordinates.longitude,
    };

    if (this.data.schudeledDate) {
      filter.schudeledDate = refreshSchudeledDate
        ? this.getDateFormat()
        : this.data.schudeledDate;
    }

    this.searchSuppliers(filter);
  }

  openGoogleMaps(lat: number, lng: number): void {
    const url = `https://www.google.com/maps?q=${lat},${lng}&z=15&output=embed`;
    window.open(url, '_blank');
  }

  onContactChange(event: any, id: string) {
    let currentContactValue = event.checked;

    this.workLoadSvc.updatePendingContact(id, currentContactValue).subscribe({
      next: (data) => {
        this.toastr.success(
          'Actualización',
          'Contacto con cliente actualizado correctamente.'
        );
      },
      error: (ex) => {
        this.pendingContactForm.controls.hasClientContact.patchValue(
          !currentContactValue
        );
        this.toastr.error('Error', ex.error.error);
      },
    });
  }

  onPaidLaborChange(event: any, id: Guid) {
    let currentValue = event.checked;

    Swal.fire({
      title: 'Ingrese una observación',
      input: 'text',
      confirmButtonColor: '#215986',
      confirmButtonText: 'Guardar',
      inputValidator: (value) => {
        if (!value) {
          return '¡Debes ingresar una observación!';
        }
        this.updatePaidLabor(id, value);
        return '';
      },
    }).then((result) => {
      if (!result.isConfirmed) {
        this.paidLaberForm.controls.isPaidLabor.patchValue(!currentValue);
      }
    });
  }

  updatePaidLabor(id: Guid, observation: string) {
    let isPaidLabor = this.paidLaberForm.controls['isPaidLabor'].value;

    const model: PaidLaborUpdateModel = {
      isPaidLabor: isPaidLabor,
      observation: observation,
    };

    this.workLoadSvc.updatePaidLabor(id.toString(), model).subscribe({
      next: (data) => {
        this.dataToUse.isPaidLabor = isPaidLabor;
        this.data.isPaidLabor = isPaidLabor;
        this.toastr.success(
          'Actualización',
          'Información actualizada correctamente.'
        );
      },
      error: (ex) => {
        this.paidLaberForm.controls.isPaidLabor.patchValue(!isPaidLabor);
        this.toastr.error('Error', ex.error.error);
      },
    });
  }

  onNoClick(): void {
    this.dialogRef.close({});
  }

  getProductQualityList() {
    this.productSvc
      .getProductQualityList()
      .subscribe((data: ProductQualityModel[]) => {
        this.productsQualityList = data;
      });
  }

  getProductColors(prodId: any) {
    this.productSvc.getProduct(prodId).subscribe((data: ProductModel) => {
      if (data) {
        this.colorList = data.productColors;
      }
    });
  }

  getFranchises() {
    this.workLoadSvc.getAllFranchises().subscribe((data: FranchiseModel[]) => {
      if (data) {
        this.franchiseList = data;
      }
    });
  }

  async getDistributionCenters() {
    this.distributionsCenterList = await lastValueFrom(
      this.workLoadSvc.getDistributionCenters()
    );
  }

  updateRevetmentSurplus(id: Guid) {
    if (this.revetmentSurplusForm.controls['revetmentSurplus'].valid) {
      let revetment =
        this.revetmentSurplusForm.controls['revetmentSurplus'].value;
      this.workLoadSvc
        .updateRevetmentSurplus(id.toString(), revetment)
        .subscribe({
          next: (data) => {
            this.dataToUse.revetmentSurplus = revetment;
            this.data.revetmentSurplus = revetment;
            this.toastr.success(
              'Actualización',
              'Información actualizada correctamente.'
            );
          },
          error: (ex) => {
            this.toastr.error('Error', ex.error.error);
          },
        });
    }
  }

  updateDuration(id: Guid) {
    if (this.durationForm.controls.estimatedDuration.valid) {
      let duration = this.durationForm.controls.estimatedDuration.value;
      this.workLoadSvc.updateDuration(id.toString(), duration).subscribe({
        next: (data) => {
          this.dataToUse.estimatedDuration = duration;
          this.data.estimatedDuration = duration;
          this.toastr.success(
            'Actualización',
            'Duración de la tarea actualizada correctamente.'
          );
        },
        error: (ex) => {
          this.toastr.error('Error', ex.error.title);
        },
      });
    }
  }

  updateDeliveryOrder(id: Guid) {
    if (this.deliveryOrderForm.controls.deliveryOrder.valid) {
      let order = this.deliveryOrderForm.controls.deliveryOrder.value;
      this.workLoadSvc.updateDeliveryOrder(id.toString(), order).subscribe({
        next: (data) => {
          this.dataToUse.deliveryOrder = order;
          this.data.deliveryOrder = order;
          this.toastr.success(
            'Actualización',
            'Orden de entrega actualizada correctamente.'
          );
        },
        error: (ex) => {
          this.toastr.error('Error', ex.error.title);
        },
      });
    }
  }

  updateVisit() {
    let relatedTaskId = this.visitForm.controls.selectedVisitId.value;
    this.workLoadSvc.updateVisit(this.data.id, relatedTaskId).subscribe({
      next: (result) => {
        this.action = '';
        this.syncPaidLaborState();
        this.getSiteVisitReports();
        this.toastr.success(
          'Actualización',
          'Visita de terreno asociado a la tarea correctamente.'
        );
      },
      error: (ex) => {
        this.toastr.error(
          'Error',
          'No se pudo asociar la visita de terreno a la tarea.'
        );
      },
    });
  }

  updateDistribuionCenter() {
    let centroDistribucionId =
      this.centroDistribucionForm.controls.centroDistribucionId.value;
    let centroDistribucionName = this.distributionsCenterList.find(
      (x) => x.id == centroDistribucionId
    )?.name;

    this.workLoadSvc
      .updateDistribuionCenter(this.data.id, centroDistribucionId)
      .subscribe({
        next: (result) => {
          this.action = '';
          this.syncPaidLaborState();
          this.data.distributionCenterId = centroDistribucionId;
          this.data.distributionCenterName = centroDistribucionName;
          this.toastr.success(
            'Actualización',
            'Centro de Distribución asignado a la tarea actualizado correctamente.'
          );
        },
        error: (ex) => {
          this.toastr.error(
            'Error',
            'No se pudo asociar Centro de Distribución a la tarea.'
          );
        },
      });
  }

  updateFranchise(id: string) {
    let franchiseId = this.franchiseForm.controls.franchiseId.value;
    this.workLoadSvc.updateFranchiseName(id, franchiseId).subscribe({
      next: (resp) => {
        this.action = '';
        this.syncPaidLaborState();
        this.initializeData();
        this.toastr.success(
          'Actualización',
          'Franquicia correctamente actualizada en la tarea.'
        );
      },
      error: (ex) => {
        this.toastr.error(
          'Error',
          'No se pudo asociar la tarea a la franquicia.'
        );
      },
    });
  }

  updateWarrantyNumber(externalIdentifier: string) {
    let warrantyNumber =
      this.warrantyForm.controls.poolWarrantyNumber.value == null
        ? ''
        : this.warrantyForm.controls.poolWarrantyNumber.value.toString();
    if (this.warrantyForm.valid) {
      this.assemblySvc
        .updateWarrantyNumber(externalIdentifier, warrantyNumber)
        .subscribe({
          next: (resp) => {
            this.toastr.success(
              'Actualización',
              'Número de garantía actualizado correctamente.'
            );
          },
          error: (ex) => {
            this.toastr.error(
              'Error',
              'Error en actualización de número de garantía.'
            );
          },
        });
    }
  }

  updateDiscount(id: string) {
    let isPromotional = this.promotionalTaskForm.controls.isPromotional.value;
    let discountApplied =
      this.promotionalTaskForm.controls.discountApplied.value;

    this.workLoadSvc
      .updatePromotionalTask(id, discountApplied, isPromotional)
      .subscribe({
        next: (result) => {
          this.toastr.success(
            'Actualización',
            'Descuento de tarea promocional actualizado correctamente.'
          );
        },
        error: (ex) => {
          this.toastr.error(
            'Error',
            'Error en actualización del porcentaje de descuento.'
          );
        },
      });
  }

  disablePromotionalForm() {
    if (this.action != 'Edit') {
      this.promotionalTaskForm.controls.discountApplied.disable();
      return;
    }
    this.promotionalTaskForm.controls.discountApplied.enable();
  }

  UpdateProduct(taskId: string) {
    let productColorId = this.productForm.controls.productColorId.value;

    let productQualityId = this.productForm.controls.productQualityId.value;

    if (productColorId != this.data.productColorId) {
      let color = this.colorList.find((x) => x.id == productColorId)?.color;
      this.workLoadSvc.UpdateProductColor(taskId, productColorId).subscribe(
        (res) => {
          this.dataToUse.productColorId = productColorId;
          this.dataToUse.productColorName = color;
          this.data.productColorId = productColorId;
          this.data.productColorName = color;
          this.toastr.success(
            'Actualización',
            'Color actualizado correctamente.'
          );
        },
        (ex) => {
          let message = ex.error.error ?? ex.error;
          this.toastr.error('Error', message);
        }
      );
    }

    if (productQualityId != this.data.productQualityId) {
      let quality = this.productsQualityList.find(
        (x) => x.id == productQualityId
      )?.name;
      this.workLoadSvc.UpdateProductQuality(taskId, productQualityId).subscribe(
        (res) => {
          this.dataToUse.productQualityId = productQualityId;
          this.dataToUse.productQualityName = quality;
          this.data.productQualityId = productQualityId;
          this.data.productQualityName = quality;
          this.toastr.success(
            'Actualización',
            'Calidad actualizada correctamente.'
          );
        },
        (ex) => {
          let message = ex.error.error ?? ex.error;
          this.toastr.error('Error', message);
        }
      );
    }
  }

  searchSuppliers(filter: ContractorSearchModel) {
    this.waitingCustomers = true;
    this.supplierList = [];
    this.supplierSvc.search(filter).subscribe(
      (res: any[]) => {
        if (res.length > 0) {
          this.supplierList = res;
          this.waitingCustomers = false;
          if (
            this.selectedSupplier &&
            this.selectedSupplier.id != Guid.createEmpty()
          ) {
            if (
              !this.supplierList.find((x) => x.id == this.selectedSupplier?.id)
            ) {
              this.contractorError =
                'Prestador no disponible en la franja horaria';
            }
          }

          this.contractor.controls.contractorName.valueChanges.subscribe(
            (value) => {
              this.selectedSupplier = null as unknown as SupplierModel;
              value = value ?? '';
              const filterValue = value.toLowerCase();

              let result = this.supplierList.filter((option) =>
                option.fullName.toLowerCase().includes(filterValue)
              );
              this.filteredOptions = of(result);
            }
          );

          this.contractor.controls.contractorName.patchValue(
            this.data.contractorName
          );
        } else {
          this.contractorError =
            (!filter.latitude || !filter.longitude
              ? `El cliente no tiene coordenadas cargadas.\n`
              : `No hay prestadores disponibles para las condiciones seleccionadas.\n`) +
            (this.currentContractorName
              ? `Actualmente asignado a ${this.currentContractorName.toUpperCase()}`
              : ``);
          this.supplierSvc.getAll().subscribe({
            next: (res) => {
              this.selectedSupplier = res.find(
                (x: SupplierModel) => x.fullName == this.currentContractorName
              );
              if (this.selectedSupplier) {
                this.deleteContractorCounter++;
                if (this.deleteContractorCounter > 2) {
                  this.removeTaskConstractor(this.data.id);
                }
              }
            },
          });
        }
      },
      (err) => {
        console.error(err.message);
      }
    );
  }

  optionClicked(event: Event, supplier: SupplierModel) {
    event.stopPropagation();
    this.selectedSupplier = supplier;
    this.contractorError = '';
  }

  onKeyDownInSupplier(event: KeyboardEvent, supplier: SupplierModel): void {
    if (event.key === 'Enter') {
      this.optionClicked(event, supplier);
    }
  }

  updateTaskDescription(id: Guid) {
    if (this.details.controls['details'].valid) {
      let description = this.details.controls['details'].value;
      this.workLoadSvc
        .updateTaskDescription(id.toString(), description)
        .subscribe(
          (data) => {
            this.dataToUse.details = description;
            this.data.details = description;
            this.toastr.success(
              'Actualización',
              'Información actualizada correctamente.'
            );
          },
          (ex) => {
            this.toastr.error('Error', ex.error.error);
          }
        );
    }
  }

  removeTaskConstractor(id: Guid) {
    this.deleteContractorCounter = 1;
    this.swalFire
      .SwalFireQuestion(
        'Actualización',
        '¿Desea quitar el prestador asignado a esta tarea?',
        'Continuar',
        'Volver'
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.updateTaskContractor(id, true);
          this.contractor.controls.contractorName.reset();
        }
      });
  }

  enableEdition() {
    this.action = 'Edit';
    this.syncPaidLaborState();
    this.contractor.controls.contractorName.enable();
    this.details.enable();
    this.schudeledDate.controls.date.enable();
    this.checkDisabledRevetmentSurplus();
    this.checkDisabledWarrantiNumber();
    this.disablePromotionalForm();
    this.disableSerialNumberForm();
    this.disableDurationForm();
    this.disableDeliveryOrderForm();
    this.getVisits(this.data.clientId);
  }

  updateTaskContractor(id: Guid, remove: boolean = false) {
    let contractorId =
      this.selectedSupplier && !remove
        ? this.selectedSupplier.id.toString()
        : null;
    this.selectedSupplier = !remove
      ? this.selectedSupplier
      : (null as unknown as SupplierModel);
    this.currentContractorName =
      this.selectedSupplier && !remove ? this.selectedSupplier.fullName : '';

    this.workLoadSvc
      .updateTaskContractor(id.toString(), contractorId)
      .subscribe(
        (data) => {
          this.dataToUse.contractorId = this.selectedSupplier
            ? this.selectedSupplier.id
            : Guid.EMPTY;
          this.dataToUse.contractorName = this.selectedSupplier?.fullName;
          this.dataToUse.contractorDni = this.selectedSupplier?.dni;
          this.dataToUse.contractorId = this.selectedSupplier?.id;
          this.dataToUse.status = data;

          this.data.contractorId = this.selectedSupplier
            ? this.selectedSupplier.id
            : Guid.EMPTY;
          this.data.contractorName = this.selectedSupplier?.fullName;
          this.data.contractorDni = this.selectedSupplier?.dni;
          this.data.contractorId = this.selectedSupplier?.id;
          this.data.status = data;
          this.getStatus(data);

          this.toastr.success(
            'Actualización',
            'El prestador se actualizó correctamente.'
          );
        },
        (ex) => {
          this.toastr.error('Error', ex.error.error);
        }
      );
  }

  removeTaskSchedule(id: Guid) {
    this.swalFire
      .SwalFireQuestion(
        'Actualización',
        '¿Desea quitar la programación de esta tarea?',
        'Continuar',
        'Volver'
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.updateTaskSchedule(id, true, false);
        }
      });
  }

  getDateFormat() {
    let date = new Date(this.schudeledDate.controls['date'].value);
    let time = this.schudeledDate.controls['time'].value?.split(':');

    let localDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      time[0],
      time[1],
      0
    );
    return this.datepipe.transform(
      localDate,
      'yyyy-MM-ddTHH:mm:ss' + this.getOffSet()
    );
  }

  onDateChange() {
    const selectedDateValue = this.schudeledDate.controls['date'].value;
    const selectedDate = new Date(selectedDateValue);
    const currentDate = new Date();
    let actualDate: boolean = false;
    const marginDate = new Date(currentDate);
    // Margen de 2 minnutos por si el usuario demora en guardar los cambios
    marginDate.setMinutes(currentDate.getMinutes() - 2);

    if (
      selectedDate.getDate() === currentDate.getDate() &&
      selectedDate.getMonth() === currentDate.getMonth() &&
      selectedDate.getFullYear() === currentDate.getFullYear()
    ) {
      this.minHour = this.datepipe.transform(marginDate, 'HH:mm') as string;
      if (this.minHour > this.schudeledDate.controls['time'].value)
        actualDate = true;
    }
    return actualDate;
  }

  updateTaskSchedule(id: Guid, remove: boolean, contactClient: boolean) {
    this.disabledSchedule = true;
    setTimeout(() => {
      this.disabledSchedule = false;
    }, 10000);
    let newSchedule: any = null;

    if (!remove && this.schudeledDate.invalid) return;

    if (!remove) {
      newSchedule = this.getDateFormat();
    }

    this.workLoadSvc
      .updateTaskSchedule(id.toString(), newSchedule, contactClient)
      .subscribe({
        next: (data) => {
          this.dataToUse.schudeledDate = !remove ? newSchedule : null;
          this.dataToUse.status = data;
          this.data.schudeledDate = !remove ? newSchedule : null;
          this.data.status = data;
          this.getStatus(data);
          if (remove) {
            this.schudeledDate.controls['date'].patchValue(null);
            this.schudeledDate.controls['time'].patchValue(null);

            this.schudeledDate.markAsUntouched();
          }
          if (!contactClient) {
            this.pendingContactForm.controls.hasClientContact.patchValue(false);
          }

          if (this.onDateChange()) {
            this.toastr.warning(
              'Advertencia',
              'La hora se ha actualizado a la hora actual por estar agendada para la fecha actual.'
            );
            this.schudeledDate.controls['time'].patchValue(this.minHour);
          }

          this.disabledSchedule = true;
          this.initContractorList();
          this.toastr.success(
            'Actualización',
            'La programación se actualizó correctamente.'
          );
        },
        error: (ex) => {
          this.toastr.error('Error', ex.error.error);
        },
      });
  }

  cancelTask(id: Guid) {
    if (this.cancel.valid) {
      this.swalFire
        .SwalFireQuestion(
          'Cancelación',
          '¿Esta seguro que desea cancelar esta tarea?',
          'Cancelar tarea',
          'Volver'
        )
        .then((result) => {
          if (result.isConfirmed) {
            this.confirmCancelTask(id);
          }
        });
    }
  }

  updateTaskStatus(id: Guid, title: string) {
    if (this.postponeOrToBudge.valid) {
      this.swalFire
        .SwalFireQuestion(
          title,
          '¿Esta seguro que desea cambiar el estado de esta tarea?',
          'Continuar',
          'Volver'
        )
        .then((result) => {
          if (result.isConfirmed) {
            this.confirmPosponeTask(id);
          }
        });
    }
  }

  CloseTask(id: Guid) {
    this.swalFire
      .SwalFireQuestion(
        'Cerrar',
        '¿Esta seguro que desea cerrar esta tarea?',
        'Continuar',
        'Volver'
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.confirmCloseTask(id);
        }
      });
  }

  getOffSet(): string {
    let offSet = new Date().getTimezoneOffset() / -60;
    let offSetFormated = Math.abs(offSet).toString().padStart(2, '0');
    return (offSet >= 0 ? '+' : '-') + offSetFormated + ':00';
  }

  uncancelTask(worktaskId: string) {
    this.swalFire
      .SwalFireQuestion(
        'Descancelar',
        '¿Esta seguro que desea descancelar esta tarea?',
        'Continuar',
        'Volver'
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.workLoadSvc.uncancelTask(worktaskId).subscribe({
            next: (res) => {
              this.toastr.success(
                'Descancelada',
                'La tarea se descanceló correctamente.'
              );
            },
            error: (err) => {
              this.toastr.success('Error', 'No se pudo descancelar la tarea.');
            },
          });
        }
      });
  }

  confirmCancelTask(id: Guid) {
    let cancel = taskStatuses.find((x) => x.code == 'Cancelada');
    let cancelDetails = this.cancel.controls['details'].value;
    if (cancel) {
      this.workLoadSvc
        .updateStatusTask(id.toString(), cancelDetails, cancel.value)
        .subscribe(
          (data) => {
            this.data.status = cancel.value;
            this.getStatus(cancel.value); // the status chip shows "Cancelada" right away
            this.taskCanceled = true;
            this.cancel.controls['details'].disable();

            this.toastr.success(
              'Cancelación',
              'La tarea se canceló correctamente.'
            );
            this.dataToUse.status = cancel.value;
          },
          (ex) => {
            this.toastr.error('Error', ex.error.error);
          }
        );
    }
  }

  confirmPosponeTask(id: Guid) {
    let newStatus = taskStatuses.find((x) => x.code == this.action);
    let newStatusDetails = this.postponeOrToBudge.controls['details'].value;
    if (newStatus) {
      this.workLoadSvc
        .updateStatusTask(id.toString(), newStatusDetails, newStatus.value)
        .subscribe({
          next: (data) => {
            this.data.status = newStatus.value;
            this.taskPostponed = true;
            this.postponeOrToBudge.controls['details'].disable();

            this.toastr.success(
              'Posponer',
              'El estado de la tarea se actualizo correctamente.'
            );
            this.dataToUse.status = newStatus.value;
          },
          error: (ex) => {
            this.toastr.error('Error', ex.error.error);
          },
        });
    }
  }

  confirmCloseTask(id: Guid) {
    let close = taskStatuses.find((x) => x.code == 'Cerrada');
    if (close) {
      this.workLoadSvc
        .updateStatusTask(id.toString(), 'Cerrada', close.value)
        .subscribe(
          (data) => {
            this.dataToUse.status = close.value;
            this.data.status = close.value;
            this.taskClosed = true;

            this.toastr.success('Cerrar', 'La tarea se cerró correctamente.');
          },
          (ex) => {
            this.toastr.error('Error', ex.error.error);
          }
        );
    }
  }

  //esto es para validar los botones
  validateNotStatusList(id: any, codes: string[]) {
    //For use in html
    let status = taskStatuses.find((x) => x.value == id)?.code;
    return status ? !codes.includes(status) : true;
  }

  validateCancelStatus(id: any) {
    let status = taskStatuses.find((x) => x.value == id)?.code;
    return status === 'Cancelada';
  }

  // For use in html: a field's "Guardar" is enabled only when its value differs from the task's.
  hasChanged(form: UntypedFormGroup, control: string, original: unknown): boolean {
    const normalize = (value: unknown) => (value === null || value === undefined ? '' : String(value));
    return normalize(form.controls[control]?.value) !== normalize(original);
  }

  validateStatusList(id: any, codes: string[]) {
    //For use in html
    let status = taskStatuses.find((x) => x.value == id)?.code;
    return status ? codes.includes(status) : false;
  }

  getStatusList() {
    this.workLoadSvc.getStatusList().subscribe((data) => {
      // Se valida y actualiza que lo que esta configurado en el back es lo
      // mismo que tenemos en front junto con el resto de las congiguraciones
      for (let key of Object.keys(data)) {
        let val = data[key];
        // this.statusList.forEach((x) => {
        taskStatuses.forEach((x) => {
          if (x.code == val) {
            x.value = Number(key);
          }
        });
      }
    });
  }

  processFields(fields: CompletedFieldModel[]) {
    fields.forEach((field) => {
      field.labels = field.labels?.trim()
        ? JSON.parse(field.labels)
        : [];
      field.values = JSON.parse(field.values ?? '[]');
      field.autoHideValues = field.autoHide ? JSON.parse(field.autoHide) : null;
      field.conditionValues = field.condition
        ? JSON.parse(field.condition)
        : null;
    });
  }

  getForms() {
    if (this.data.hasEndingReport) {
      this.formsSrv.getCompletionFormForTask(this.data.id).subscribe((data) => {
        data.forEach((form) => {
          form.groups.forEach((group) => {
            this.processFields(group.fields);
          });
        });

        this.completionFroms = data;
      });
    }

    if (this.data.hasSiteVisitReport) {
      this.getSiteVisitReports();
    }

    if (this.data.hasEvaluationReport) {
      this.formsSrv.getEvaluationFormForTask(this.data.id).subscribe((data) => {
        this.evaluationForm = data;
        this.evaluationForm?.forEach((form) => {
          form.groups.forEach((group) => {
            this.processFields(group.fields);
          });
        });
      });
    }

    if (this.data.hasStartingReport) {
      this.formsSrv.getStartingFormForTask(this.data.id).subscribe((data) => {
        this.startingForms = data;
        this.startingForms?.forEach((form) => {
          form.groups.forEach((group) => {
            this.processFields(group.fields);
          });
        });
      });
    }

    if (this.showTransportationReport()) {
      this.getTransportationReports(this.data.id);
    }

    this.fileServerSrv
      .GetTaskFiles(this.data.id, this.fileServerSrv.Tasks, 'ProgressImages')
      .subscribe({
        next: (dataimg) => {
          dataimg.forEach((img) => {
            this.progressImages.push({
              id: img.id,
              groupId: 'ProgressImages',
              name: img.name,
              imageSrc: img.publicUrl,
              mediaType: img.mediaType,
            });
          });
        },
        // The progress images are optional: if the files service fails the detail still works, without them.
        error: (err) => console.error('No se pudieron cargar las imágenes de avance de obra', err.message),
      });
  }

  getTransportationReports(taskId: string) {
    this.workTaskSvc
      .getClientVisitsReports(taskId, 1)
      .subscribe({
        next: (data) => {
          data.forEach((form) => {
            form.groups.forEach((group) => {
              this.processFields(group.fields);
            });
          });

          this.transportationForms = data;
        },
        error: (err) => {
          console.error(err);
        }
      });
  }

  getSiteVisitReports() {
    this.workTaskSvc
      .getClientVisitsReports(this.currentTaskId.toString(), 4)
      .subscribe({
        next: (data) => {
          data.forEach((form) => {
            form.groups.forEach((group) => {
              this.processFields(group.fields);
            });
          });

          this.siteVisitCompletionFrom = data;
        },
      });
  }

  getScheduleInfoLabel() {
    return this.schudeledDate.controls['date']?.value;
  }

  getStatus(status: any) {
    this.taskCurrentStatus = taskStatuses.find((x) => x.value == status);
  }

  getThirdPartyAppName(fromThirdPartyApp: number) {
    let thirdPartyAppName: any;
    thirdPartyAppName = this.thirdPartyAppList.find(
      (x) => x.id == fromThirdPartyApp
    )?.name;

    return thirdPartyAppName ?? '';
  }

  editableRevetmentSurplusTasks() {
    let taskType = this.data.taskType;
    const revetmentTasksTypes = [
      'Revestimiento',
      'Piscina',
      'Piscina y Equipamiento',
      'Entrega',
      'Carga',
    ];
    if (revetmentTasksTypes.includes(taskType)) return true;

    return false;
  }

  updateFilterSerialNumber() {
    if (this.serialNumberForm.controls.filterSerialNumber.valid) {
      let filterSerialNumber =
        this.serialNumberForm.controls.filterSerialNumber.value;
      this.assemblySvc
        .updatefilterSerialNumber(
          this.data.externalIdentifier,
          filterSerialNumber
        )
        .subscribe({
          next: (data) => {
            this.dataToUse.filterSerialNumber = data.filterSerialNumber;
            this.data.filterSerialNumber = data.filterSerialNumber;
            this.toastr.success(
              'Actualización',
              'Número de serie del filtro actualizado correctamente.'
            );
          },
          error: (ex) => {
            this.toastr.error('Error', ex.error.title);
          },
        });
    }
  }

  updateValveSelectorSerialNumber() {
    if (this.serialNumberForm.controls.valveSelectorSerialNumber.valid) {
      let valveSerialNumber =
        this.serialNumberForm.controls.valveSelectorSerialNumber.value;
      this.assemblySvc
        .updatevalveSelectorSerialNumber(
          this.data.externalIdentifier,
          valveSerialNumber
        )
        .subscribe({
          next: (data) => {
            this.dataToUse.valveSelectorSerialNumber =
              data.valveSelectorSerialNumber;
            this.data.valveSelectorSerialNumber =
              data.valveSelectorSerialNumber;
            this.toastr.success(
              'Actualización',
              'Número de serie de la valvula actualizado correctamente.'
            );
          },
          error: (ex) => {
            this.toastr.error('Error', ex.error.title);
          },
        });
    }
  }

  editSerialNumber() {
    let taskType = this.data.taskType;
    const serialNumberTypes = ['Piscina y Equipamiento', 'Equipamiento'];
    if (
      serialNumberTypes.includes(taskType) &&
      (this.usrSvc.hasPermission('edit:valveSelectorSerialNumber') ||
        this.usrSvc.hasPermission('edit:filterSerialNumber'))
    ) {
      return true;
    }
    return false;
  }

  editableTaskDuration() {
    let jobGroup = this.data.jobGroup;
    if (
      jobGroup == 'Transporte' &&
      this.usrSvc.hasPermission('edit:durationtask')
    )
      return true;

    return false;
  }

  editableDeliveryOrder() {
    let jobGroup = this.data.jobGroup;
    let taskType = this.data.taskType;
    if (
      jobGroup == 'Transporte' &&
      taskType == 'Entrega' &&
      this.usrSvc.hasPermission('edit:durationtask')
    )
      return true;

    return false;
  }

  validateOnlyNumbers(event: KeyboardEvent): void;
  validateOnlyNumbers(
    event: KeyboardEvent,
    formGroup: UntypedFormGroup,
    formController: string,
    limit: number
  ): void;
  validateOnlyNumbers(
    event: KeyboardEvent,
    formGroup?: UntypedFormGroup,
    formController?: string,
    limit?: number
  ) {
    let key = event.key;
    let inputElement = event.target as HTMLInputElement;
    if (
      !/\d/.test(key) &&
      key !== 'Backspace' &&
      key !== 'ArrowLeft' &&
      key !== 'ArrowRight' &&
      key !== 'Tab'
    ) {
      event.preventDefault();
    }

    const paramsProvided = [formGroup, formController, limit].filter(
      (param) => param !== undefined
    ).length;
    if (paramsProvided > 0 && paramsProvided < 3)
      throw new Error(
        'Si se proporciona uno de los parametros (formGroup, formController, limit), los tres deben ser enviados.'
      );

    if (formGroup && formController && limit) {
      setTimeout(() => {
        const durationValue = Number.parseFloat(inputElement.value) || 0;
        const maxAllowDuration = limit;
        if (durationValue > maxAllowDuration) {
          inputElement.value = maxAllowDuration.toString();
          formGroup.controls[formController].patchValue(maxAllowDuration);
        }
      });
    }
  }

  editableWarrantyNumberAndPaidLabor() {
    let taskType = this.data.taskType;
    let jobGroup = this.data.jobGroup;
    if (
      jobGroup == 'Instalar' &&
      (taskType == 'Piscina' || taskType == 'Piscina y Equipamiento')
    )
      return true;

    return false;
  }

  showTransportationReport() {
    let taskType = (this.data.taskType || '').toLowerCase();
    let jobGroup = (this.data.jobGroup || '').toLowerCase();
    if (
      jobGroup === 'transporte' &&
      (taskType === 'carga' || taskType === 'entrega')
    )
      return true;

    return false;
  }

  disableEnableControl(form: UntypedFormGroup, formControl: string) {
    if (this.action != 'Edit') {
      form.controls[formControl].disable();
      return;
    }
    form.controls[formControl].enable();
  }

  checkDisabledRevetmentSurplus() {
    if (this.editableRevetmentSurplusTasks()) {
      this.disableEnableControl(this.revetmentSurplusForm, 'revetmentSurplus');
    }
  }

  disableDurationForm() {
    if (this.editableTaskDuration()) {
      this.disableEnableControl(this.durationForm, 'estimatedDuration');
    }
  }

  disableSerialNumberForm() {
    if (this.editSerialNumber()) {
      const controls = ['filterSerialNumber', 'valveSelectorSerialNumber'];
      controls.forEach((controlName) => {
        this.disableEnableControl(this.serialNumberForm, controlName);
      });
    }
  }

  disableDeliveryOrderForm() {
    if (this.editableDeliveryOrder()) {
      this.disableEnableControl(this.deliveryOrderForm, 'deliveryOrder');
    }
  }

  checkDisabledWarrantiNumber() {
    if (this.editableWarrantyNumberAndPaidLabor()) {
      this.disableEnableControl(this.warrantyForm, 'poolWarrantyNumber');
    }
  }

  userCanEditTask() {
    let result =
      (this.usrSvc.hasPermission('edit:workload') ||
        (this.usrSvc.hasPermission('edit:terrain') &&
          this.data.taskTypeId == this.TERRAIN_VISIT_ID)) &&
      this.validateNotStatusList(this.data.status, [
        'Cancelada',
        'Finalizada',
        'Cerrada',
      ]);

    return result;
  }

  // Applies disablePaidLaborCheck() to the control: [disabled] in the template warns when combined with formControlName.
  syncPaidLaborState() {
    const control = this.paidLaberForm?.controls['isPaidLabor'];
    if (!control) return;
    if (this.disablePaidLaborCheck()) {
      control.disable({ emitEvent: false });
    } else {
      control.enable({ emitEvent: false });
    }
  }

  disablePaidLaborCheck() {
    if (this.action == 'Edit' && this.canEditPaidLabor) {
      return false;
    }

    if (
      this.action != 'Edit' &&
      this.userCanEditTask() &&
      this.canEditPaidLabor
    ) {
      return false;
    }

    return true;
  }

  openMedia(url: any) {
    window.open(url, '_blank');
  }

  openClientInfo() {
    const ref = this.dialog.open(ClientInfoModalComponent, {
      width: '700px',
      data: { workloadId: this.data.workloadId }
    });
    ref.afterClosed().subscribe((newClientInfo) => {
      if (!newClientInfo) return;

      this.data.client = newClientInfo.client;
      this.data.address = newClientInfo.address;

      this.initializeData();

      this.cdRef.detectChanges();
    });
  }

  get anyMenuItemVisible(): boolean {
    const { data, usrSvc } = this;
    const canChangeClient = usrSvc.hasPermission('change:task-client');

    const canEdit = this.userCanEditTask();
    const canCancel =
      (usrSvc.hasPermission('cancel:workload') ||
        (usrSvc.hasPermission('cancel:terrain') && data.taskTypeId === this.TERRAIN_VISIT_ID))
      && this.validateNotStatusList(data.status, ['Cancelada', 'Finalizada', 'Cerrada']);

    const canPostpone =
      this.validateStatusList(data.status, ['Creada', 'Agendada']) &&
      usrSvc.hasPermission('postponed:workload');

    const canPresupuestar =
      this.validateStatusList(data.status, ['Creada']) &&
      usrSvc.hasPermission('postponed:workload');

    return !!(canChangeClient || canEdit || canCancel || canPostpone || canPresupuestar || this.canGenerateTask());
  }

  // "Generar tarea": a new work order for the same client at the same address (the work order wizard opens with
  // both already selected). Same permission as the "Orden de trabajo" page.
  canGenerateTask(): boolean {
    return this.usrSvc.hasPermission('add:workload') && !!this.data?.clientId;
  }

  generateTask() {
    const queryParams: Record<string, string> = { clientId: String(this.data.clientId) };
    if (this.data.address?.id) {
      queryParams['addressId'] = String(this.data.address.id);
    }
    this.dialogRef.close({});
    this.router.navigate(['/workload'], { queryParams });
  }
}
